import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.bro = bracketIndenting({
	line: "#",
})
